var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-action-btn',{attrs:{"icon":_vm.icon,"color":_vm.color,"tooltip":_vm.tooltip,"disabled":_vm.disabled || _vm.downloading,"loading":_vm.downloading},on:{"click":_vm.downloadContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }